import React from "react";
import { Scrollable } from "./styled";
export default function ScrollableContainer(props) {
    const { children } = props;
    return React.createElement(Scrollable, Object.assign({}, props), children);
}
